import crest from "../assets/bstrong-crest-white.png";
import selfie1 from "../assets/BAA Riverside.png";
import selfie2 from "../assets/BAA LI Profile.jpg";

export function Logo({ large = false }: { large?: boolean }) {
  return (
    <div className={`bsp-logo-crest ${large ? "bsp-logo-crest-large" : ""}`}>
      <img src={crest} alt="BStrong Performance" />
    </div>
  );
}

export function LogoMobile() {
  return (
    <div className="bsp-logo-crest bsp-logo-crest-mobile">
      <img src={crest} alt="BStrong Performance" />
    </div>
  );
}

export function LogoFooter() {
  return (
    <div className="bsp-logo-footer">
      <img src={crest} alt="BStrong Performance" />
      <div className="bsp-logo-word">
        <span className="bsp-logo-main">
          <span>B</span>Strong Performance
        </span>
      </div>
    </div>
  );
}

export function Selfie1() {
  return (
    <div className="bsp-headshot">
      <img src={selfie1} alt="Brian A. Armstrong" />
    </div>
  );
}

export function Selfie2() {
  return (
    <div className="bsp-headshot">
      <img src={selfie2} alt="Brian A. Armstrong" />
    </div>
  );
}
